module.exports = __webpack_public_path__ + "static/media/slim.e42499f1.svg";